import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FbModuleComponent } from './fb-module.component';
import { FbContainerComponent } from './fb-container/fb-container.component';
import { DirtyFormGuard } from 'dirty-check-store';

const routes: Routes = [
  { path: '', redirectTo: 'fb' },
  {
    path: 'fb', component: FbModuleComponent,
    children: [
      { path: 'module', component: FbContainerComponent ,canDeactivate: [DirtyFormGuard]},
      {
        path: 'employee',
        loadChildren: () => import('../beneficiary/beneficiary.module').then((mod) => mod.BeneficiaryModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FbModuleRoutingModule { }
